// @ts-nocheck
import { Button, Form } from "react-bootstrap";
import "./AnalysisActions.css";
import { useState } from "react";
import NotificationToast from "../../../../../components/NotificationToast/NotificationToast";
import ConfirmationModal from "../../../../../components/ConfirmationModal/ConfirmationModal";

export interface AnalysisActionsProps {
  onSolicitarAdequacao?: () => void | Promise<void>;
  onFinalizar?: () => Promise<{ show?: boolean; message?: string; type?: string; reload?: boolean } | void> | void;

  onFinalizarPersistir?: () => Promise<
    { show?: boolean; message?: string; type?: string; reload?: boolean } | void
  >;
  onFinalizarConfirmar?: () => Promise<
    { show?: boolean; message?: string; type?: string; reload?: boolean } | void
  >;
  onSalvar?: () => Promise<{ show?: boolean; message?: string; type?: string; reload?: boolean } | void> | void;
  onLiberarNovaSolicitacao?: () => void;
  showSolicitar?: boolean;
  showFinalizar?: boolean;
  showSalvar?: boolean;
  showLiberar?: boolean;
  showEligibilityCheck?: boolean;
  apto?: boolean;

  disabled?: boolean;
  finalizarDisabled?: boolean;
}

const AnalysisActions = ({
  onSolicitarAdequacao,
  onFinalizar,
  onFinalizarPersistir,
  onFinalizarConfirmar,
  onSalvar,
  onLiberarNovaSolicitacao,
  showSolicitar = true,
  showFinalizar = true,
  showSalvar = true,
  showLiberar = false,
  showEligibilityCheck = false,
  apto = false,
  disabled = false,
  finalizarDisabled = false,
}: AnalysisActionsProps) => {
  const [toastData, setToastData] = useState<{
    show: boolean;
    message: string;
    type: string;
  }>({
    show: false,
    message: "",
    type: "",
  });

  const [showModal, setShowModal] = useState(false);

  const handleSave = async () => {
    const fn = onSalvar ?? onFinalizar;
    if (!fn) return;

    const toastResponse = await fn();

    if (toastResponse?.show) {
      setToastData((prev) => ({
        ...prev,
        show: true,
        message: toastResponse?.message ?? prev.message,
        type: toastResponse?.type ?? prev.type,
      }));
      if (toastResponse?.reload) {
        setTimeout(() => {
          window.location.reload();
        }, 500);
      }
    }
  };

  const handleFinalizarConfirmacaoModal = async () => {
    const fn = onFinalizarConfirmar ?? onFinalizar;
    if (!fn) return;

    const toastResponse = await fn();

    if (toastResponse?.show) {
      setToastData((prev) => ({
        ...prev,
        show: true,
        message: toastResponse?.message ?? prev.message,
        type: toastResponse?.type ?? prev.type,
      }));

      if (toastResponse?.reload) {
        setTimeout(() => {
          window.location.reload();
        }, 500);
      }
    }
  };

  const handleClicarBotaoFinalizar = async () => {
    if (onFinalizarPersistir && onFinalizarConfirmar) {
      const toastResponse = await onFinalizarPersistir();
      if (toastResponse?.show && toastResponse?.type === "error") {
        setToastData((prev) => ({
          ...prev,
          show: true,
          message: toastResponse?.message ?? prev.message,
          type: toastResponse?.type ?? "error",
        }));
        return;
      }
      if (toastResponse?.show && toastResponse?.type === "success") {
        setToastData((prev) => ({
          ...prev,
          show: true,
          message: toastResponse?.message ?? prev.message,
          type: "success",
        }));
      }
    }
    setShowModal(true);
  };

  return (
    <>
      <div
        className={`analysis-actions-footer mt-4${
          showEligibilityCheck ? " analysis-actions-footer--stacked" : ""
        }`}
      >
        {showEligibilityCheck && (
          <div className="analysis-actions-apto-row text-start">
            <Form.Check
              type="switch"
              id="switch-apto"
              label="Apto a participar do Programa Meritocracia"
              checked={apto}
              disabled
              className={`analysis-actions-apto-switch mb-0${
                disabled ? " opacity-50" : ""
              }`}
            />
          </div>
        )}
        <div className="analysis-actions-buttons-row d-flex align-items-center justify-content-end">
          <div className="save-submit-buttons d-flex gap-2">
            {showLiberar && (
              <Button
                type="button"
                variant="outline-primary"
                onClick={onLiberarNovaSolicitacao}
                className="edit-btn"
              >
                LIBERAR NOVA SOLICITAÇÃO
              </Button>
            )}

            <Button
              type="button"
              variant={showSolicitar ? "info" : "secondary"}
              onClick={showSolicitar ? () => void onSolicitarAdequacao?.() : undefined}
              disabled={disabled || !showSolicitar}
              className="edit-btn"
            >
              SOLICITAR ADEQUAÇÃO
            </Button>

            {showSalvar && (
              <Button
                type="button"
                variant="primary"
                onClick={handleSave}
                className="save-btn"
                disabled={disabled}
              >
                SALVAR
              </Button>
            )}

            {showFinalizar && (
              <Button
                type="button"
                variant="success"
                onClick={() => void handleClicarBotaoFinalizar()}
                className="sucess-btn"
                disabled={disabled || finalizarDisabled}
              >
                FINALIZAR
              </Button>
            )}
          </div>
        </div>
      </div>

      <NotificationToast
        show={toastData.show}
        onClose={() => setToastData((prev) => ({ ...prev, show: false }))}
        message={toastData.message}
        type={toastData.type}
      />

      <ConfirmationModal
        isOpen={showModal}
        title="Confirmar Finalização"
        message={
          <>
            Ao clicar em <strong>"Finalizar"</strong>, as informações serão
            enviadas para cálculo do apoio.
            <br />
            <br />
            Deseja realmente finalizar a análise desse sindicato?
          </>
        }
        onConfirm={async () => {
          setShowModal(false);
          await handleFinalizarConfirmacaoModal();
        }}
        onCancel={() => setShowModal(false)}
      />
    </>
  );
};

export default AnalysisActions;
